export const NONFICTION_FORMAL_AUDIENCE = 'Nonfiction - Formal';
export const NONFICTION_INFORMAL_AUDIENCE = 'Nonfiction - Informal';

export const INTENDED_AUDIENCE_PRESETS = [
  'Children',
  'Middle Grade',
  'Young Adult',
  'Teens',
  'New Adult',
  'Adult',
  'Clean Romance Readers',
  'MM Romance Readers',
  'FF Romance Readers',
  NONFICTION_FORMAL_AUDIENCE,
  NONFICTION_INFORMAL_AUDIENCE,
  'All Ages',
];

export const normalizeAudienceKey = (value: string): string => value.trim().toLowerCase();

export const splitAndDedupeAudienceValues = (values: string[]): string[] => {
  const seen = new Set<string>();
  const result: string[] = [];
  values.forEach(rawValue => {
    (rawValue || '')
      .split(',')
      .map(part => part.trim())
      .filter(Boolean)
      .forEach(part => {
        const key = normalizeAudienceKey(part);
        if (seen.has(key)) return;
        seen.add(key);
        result.push(part);
      });
  });
  return result;
};

export const enforceNonfictionAudienceExclusivity = (
  values: string[],
  protectedValues: string[] = [],
): string[] => {
  const formalKey = normalizeAudienceKey(NONFICTION_FORMAL_AUDIENCE);
  const informalKey = normalizeAudienceKey(NONFICTION_INFORMAL_AUDIENCE);
  const protectedKeys = new Set(protectedValues.map(normalizeAudienceKey));
  const formalLocked = protectedKeys.has(formalKey);
  const informalLocked = protectedKeys.has(informalKey);
  if (formalLocked && informalLocked) {
    return splitAndDedupeAudienceValues(values);
  }

  const result: string[] = [];
  const seen = new Set<string>();
  splitAndDedupeAudienceValues(values).forEach(value => {
    const key = normalizeAudienceKey(value);
    if (formalLocked && key === informalKey) return;
    if (informalLocked && key === formalKey) return;
    if (key === formalKey) {
      for (let i = result.length - 1; i >= 0; i -= 1) {
        if (normalizeAudienceKey(result[i]) === informalKey) {
          seen.delete(informalKey);
          result.splice(i, 1);
        }
      }
    }
    if (key === informalKey) {
      for (let i = result.length - 1; i >= 0; i -= 1) {
        if (normalizeAudienceKey(result[i]) === formalKey) {
          seen.delete(formalKey);
          result.splice(i, 1);
        }
      }
    }
    if (seen.has(key)) return;
    seen.add(key);
    result.push(value);
  });
  return result;
};
